export const ITERABLE_SMS = 'Iterable SMS';
export const TELNYX_DIRECT = 'Telnyx Direct';
export const TWILIO_DIRECT = 'Twilio Direct';

export const FIRST_PARTY = 'FirstParty';
export const THIRD_PARTY = 'ThirdParty';

export const UTILITY = 'Utility';
export const MARKETING = 'Marketing';

export const USAGE_LIMITS_PREVIEW_KEY = 'billing-usage-limits';
export const USAGE_LIMITS_FF = 'BillingUsageLimits';

export * from './metricNames';
export * from './displayText';
export * from './projectBreakdown';
